(() => {
  'use strict';
  // Keep Halo's existing drawer controls and focus behaviour. Disable focus in
  // the closed mobile drawer, including links loaded asynchronously by Halo.
  const menu = document.querySelector('#navigation-mobile');
  if (menu) {
    const sync = () => { menu.inert = !document.body.classList.contains('menu_open'); };
    new MutationObserver(sync).observe(document.body, {attributes:true,attributeFilter:['class']});
    sync();
  }
})();
